export const getDevicesState = (state) => state.devices;
